import yup from 'lib/settings/yup';
import { fullNameTest } from 'lib/settings/yup/tests/fullNameTest';

export interface InputsSecondStep {
  fullName: string;
  password: string;
  repeatPassword: string;
}

export const SecondStepRegistrationSchema = yup.object({
  fullName: yup.string().test(fullNameTest()).required('Digite um nome'),
  password: yup
    .string()
    .min(8, 'Senha muito curta')
    .required('Digite uma senha'),
  repeatPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Senhas não são iguais')
    .required('Repita a senha'),
});
